import {Component, HostBinding, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DisplayTypes} from '@catui/components/panel/types';
import {isNullOrUndefined} from 'util';

const componentBaseName = 'panel';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

const styleClassByType = new Map<number, string>();
// styleClassByType.set(DisplayTypes.FullWidth, 'custom');
// styleClassByType.set(DisplayTypes.Float, 'floating');
styleClassByType.set(DisplayTypes.Flex, 'flex');
//
// {
//   'custom': type===displayTypes.FullWidth,
//   'floating':type===displayTypes.Float,
//   'flex':type===displayTypes.Flex,
//   'no-overflow':!overflow
// }

@Component({
  selector: 'cat-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent implements OnChanges {
  @HostBinding('class') classNames = defaultClassNames;

  @Input() type = DisplayTypes.Default;
  @Input() title: string;
  @Input() overflow = false;

  displayTypes = DisplayTypes;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    const hasOverflow = isNullOrUndefined(changes.overflow) ? null : changes.overflow.currentValue;
    const displayType = isNullOrUndefined(changes.type) ? null : changes.type.currentValue;
    this.updateContainerClasses(displayType, hasOverflow);

  }

  private updateContainerClasses(displayType: number, hasOverflow: boolean) {
    const classes = [defaultClassNames];
    const displayTypeClass = styleClassByType.get(displayType);

    if (displayTypeClass) {
      classes.push(displayTypeClass);
    }
    //
    // if (!isNullOrUndefined(hasOverflow) && !hasOverflow) {
    //   classes.push('no-overflow');
    // }

    this.classNames = classes.join(' ');
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-base/components/panel/panel.component.ts